var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 20C18 20.2652 18.1054 20.5196 18.2929 20.7071C18.4804 20.8946 18.7348 21 19 21C19.2652 21 19.5196 20.8946 19.7071 20.7071C19.8946 20.5196 20 20.2652 20 20V18C20 17.7348 19.8946 17.4804 19.7071 17.2929C19.5196 17.1054 19.2652 17 19 17C18.7348 17 18.4804 17.1054 18.2929 17.2929C18.1054 17.4804 18 17.7348 18 18V20ZM18 20C18 22.6522 19.0536 25.1957 20.9289 27.0711C22.8043 28.9464 25.3478 30 28 30M28 30H30C30.2652 30 30.5196 29.8946 30.7071 29.7071C30.8946 29.5196 31 29.2652 31 29C31 28.7348 30.8946 28.4804 30.7071 28.2929C30.5196 28.1054 30.2652 28 30 28H28C27.7348 28 27.4804 28.1054 27.2929 28.2929C27.1054 28.4804 27 28.7348 27 29C27 29.2652 27.1054 29.5196 27.2929 29.7071C27.4804 29.8946 27.7348 30 28 30ZM6 42.0004L9.3 34.4004C6.77533 30.8165 5.64533 26.4345 6.12209 22.0766C6.59884 17.7188 8.64957 13.6847 11.8894 10.7315C15.1293 7.77823 19.3355 6.10885 23.7188 6.03663C28.102 5.9644 32.361 7.49428 35.6964 10.3392C39.0318 13.1841 41.2143 17.1484 41.8344 21.4882C42.4544 25.8279 41.4694 30.2448 39.0642 33.91C36.659 37.5751 32.9989 40.2365 28.7708 41.3946C24.5427 42.5528 20.0373 42.1282 16.1 40.2004L6 42.0004Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.7c62f9a8ff9546ed756104e3d6d9110d.svg";
export { ForwardRef as ReactComponent };